import React from 'react';
import QRCode from "react-qr-code";
import { useAppData } from '../../../../../context/AppDataContext';

function EmployeIDCard({ employeDetails, companyDetails }) {
  // Mapping for designation IDs
  const {masters,getMasterLabel} = useAppData();

  const cardStyle = {
    width: '400px',
    height: '240px',
    background: '#ffffff',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    position: 'relative'
  };

  const topBar = {
    height: '65px',
    background: '#004680',
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    justifyContent: 'space-between'
  };

  const logoStyle = {
    height: '50px', // Increased slightly for better visibility
    maxWidth: '140px',
    objectFit: 'contain',
    display: 'block',
    margin: '0',
    padding: '0' // Explicitly removed padding
  };

  return (
    <div style={cardStyle}>
      {/* Top Header: Logo & Company Info */}
      <div style={topBar}>
        <img 
          src={companyDetails.logo} 
          alt="Company Logo" 
          style={logoStyle} 
        />
        <div style={{ textAlign: 'right', color: 'white' }}>
          <div style={{ fontSize: '13px', fontWeight: 'bold', textTransform: 'uppercase' }}>
            {companyDetails.companyName}
          </div>
          <div style={{ fontSize: '9px', opacity: 0.8 }}>
            {companyDetails.city}, {companyDetails.state}
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div style={{ display: 'flex', padding: '20px 15px', flex: 1, alignItems: 'center' }}>
        
        {/* Left: Employee Photo (Rounded) */}
        <div style={{ marginRight: '18px' }}>
          <img 
            src={employeDetails.photo} 
            alt="Profile" 
            style={{ 
              width: '85px', 
              height: '85px', 
              borderRadius: '50%', 
              border: '3px solid #004680',
              objectFit: 'cover' 
            }} 
          />
        </div>

        {/* Middle: Employee Info */}
        <div style={{ flex: 1 }}>
          <h2 style={{ margin: 0, fontSize: '19px', color: '#222', fontWeight: '700' }}>
            {employeDetails.employeeName}
          </h2>
          <p style={{ margin: '2px 0 12px 0', fontSize: '13px', color: '#0072bc', fontWeight: '600' }}>
            {getMasterLabel("employee-designation",employeDetails.employeeDesignation)}
          </p>
          
          <div style={{ fontSize: '11px', color: '#444' }}>
            <div style={{ marginBottom: '4px' }}>
              <span style={{ color: '#888', fontWeight: '500' }}>EMP CODE: </span>
              <span style={{ fontWeight: '700' }}>{employeDetails.employeeCode || "Temp-2026"}</span>
            </div>
            <div>
              <span style={{ color: '#888', fontWeight: '500' }}>PHONE: </span>
              <span style={{ fontWeight: '700' }}>{employeDetails.phone}</span>
            </div>
          </div>
        </div>

        {/* Right: Space-efficient QR Code */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          borderLeft: '1px solid #eee', 
          paddingLeft: '15px' 
        }}>
          <div style={{ padding: '4px', background: '#fff' }}>
            <QRCode 
              size={55} 
              value={`ID:${employeDetails.id} | Name:${employeDetails.employeeName} | Code:${employeDetails.employeeCode} |`} 
              viewBox={`0 0 256 256`}
            />
          </div>
          <span style={{ fontSize: '7px', color: '#aaa', marginTop: '4px', fontWeight: 'bold' }}>VERIFY</span>
        </div>
      </div>

      {/* Bottom Footer Strip */}
      <div style={{ 
        background: '#f8f9fa', 
        borderTop: '1px solid #eee', 
        padding: '6px 15px',
        fontSize: '9px',
        color: '#777',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}>
        {companyDetails.address}
      </div>
    </div>
  );
}

export default EmployeIDCard;